import React, { forwardRef, useId } from "react";
import { FormControl } from "react-bootstrap";
import "./index.css";

const Input = forwardRef((props, ref) => {
  const {
    className,
    isInvalid = false,
    hasIcon = null,
    startIcon = null,
    id = null,
    ...rest
  } = props;
  const autoId = useId();
  const resolvedId = id || autoId;
  return (<>
    <label className="visually-hidden" htmlFor={resolvedId}></label>
    <FormControl
      ref={ref}
      id={resolvedId}
      isInvalid={!!isInvalid}
      aria-invalid={!!isInvalid}
      autoComplete="off"
      className={`rounded-2 ${className} ${(hasIcon && startIcon)
        ? "start-icon"
        : hasIcon
          ? "end-icon"
          : ""
        } ${isInvalid ? "is-invalid" : ""}`.trim()}
      {...rest}
    /></>
  );
});

export default Input;
